import React from 'react'
import { connect } from 'react-redux'
import ConfirmEmail from '../../components/users/ConfirmEmail'
import { sendEmailActivation } from '../../actions/userActions'
import { bindActionCreators } from 'redux'


class ConfirmEmailContainer extends React.Component {




    render() {
        if (this.props.loggedIn) {
            this.props.history.push("/presentations")
        }
        if (this.props.activationCheck === false) {
            this.props.sendEmailActivation(this.props.match.params.id, this.props.match.params.code)
        }
        return (
            <ConfirmEmail loggedIn={this.props.loggedIn} sendEmailActivation={this.props.sendEmailActivation}  />
        )
    }
}

function mapStateToProps(state) {
    return {
        loggedIn: state.users.loggedIn,
        activationCheck: state.users.activationCheck,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ sendEmailActivation }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmEmailContainer)